import script from "./aiColorMatching.vue?vue&type=script&setup=true&name=colorSearch&lang=js"
export * from "./aiColorMatching.vue?vue&type=script&setup=true&name=colorSearch&lang=js"

const __exports__ = script;

export default __exports__